import type React from "react";
import { useAppSelector } from "../../hooks/redux-hooks";
import AppointmentSelectionModal from "../TransferButton/AppointmentSelectionModal";
import MFACodeModal from "../TransferButton/MFACodeModal";
import { useTransfer } from "../TransferButton/TransferContext";

// Mounts the appointment / note-template / MFA modals at the app shell level
// so the context state survives navigation. Modals only render while the
// clinician is on the target note's page — elsewhere the banner's "Go to note"
// CTA brings them here, and the modal pops once they land.
const TransferModalsHost: React.FC = () => {
  const {
    activeJob,
    appointmentOptions,
    showAppointmentModal,
    isSelectingAppointment,
    isNoteTypeSelection,
    showMFAModal,
    isSubmittingMFA,
    mfaOptions,
    selectAppointment,
    cancelAppointment,
    submitMFACode,
    cancelMFA,
  } = useTransfer();
  const { notesDetails } = useAppSelector((state) => state.notes);

  const isOnTargetNote = activeJob?.audio_file_id != null && notesDetails?.id === activeJob.audio_file_id;

  return (
    <>
      <AppointmentSelectionModal
        visible={showAppointmentModal && isOnTargetNote}
        appointments={appointmentOptions}
        onSelect={selectAppointment}
        onCancel={cancelAppointment}
        loading={isSelectingAppointment}
        title={isNoteTypeSelection ? "Select Note Template" : undefined}
        description={
          isNoteTypeSelection
            ? "Multiple note templates are available. Please select the template to use for this note:"
            : undefined
        }
      />
      <MFACodeModal
        visible={showMFAModal && isOnTargetNote}
        onSubmit={submitMFACode}
        onCancel={cancelMFA}
        loading={isSubmittingMFA}
        mfaOptions={mfaOptions}
      />
    </>
  );
};

export default TransferModalsHost;
